import { useTranslation } from "react-i18next";

import Cell from "../../components/common/AccordionTable/components/Cell";
import DropdownItem from "../../components/common/AccordionTable/components/DropdownTableMenu/components/DropdownItem";
import Span from "../../components/common/AccordionTable/components/Span";

export const useCheckSpamDBAdapter = () => {
  const { t } = useTranslation();

  const headerData = [t("global.name"), t("global.result")];

  const getResult = result => {
    return result ? t("global.found") : t("global.notFound");
  };

  const renderRowContent = item => {
    return (
      <>
        <Cell>{item.name}</Cell>
        <Cell>{getResult(item.result)}</Cell>
      </>
    );
  };

  const renderHeaderTitle = item => {
    return Object.values(item)[0];
  };

  const renderDropdownContent = item => {
    return (
      <>
        <DropdownItem>
          <span>{headerData[1]}</span> <Span> {getResult(item.result)}</Span>
        </DropdownItem>
      </>
    );
  };

  return {
    renderRowContent,
    renderHeaderTitle,
    renderDropdownContent,
    headerData,
  };
};
